import appGlobalScript from '/home/jamin/dev/work/calcite-design-system/main/packages/calcite-components/src/utils/globalScript.ts';
export const globalScripts = appGlobalScript;
